export default __webpack_public_path__ + "static/media/grid_xls.8e45af80.svg";